module.exports = __webpack_public_path__ + "img/ball_7.fc9b51ba.png";